import * as AlertNotification from '@givebutter/primitives/alert-notification';
import { Box } from '@givebutter/primitives/box';
import { Button } from '@givebutter/primitives/button';
import { faBank } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Dialog from 'components/dialog';
import { VerifyBankModalContent } from 'components/verify-bank';
import { WITHDRAWALS_HELP_LINK } from 'constants/links';
import { posthogEvents } from 'constants/posthog-events';
import { useAppState } from 'customHooks/useAppState';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { usePosthog } from 'customHooks/usePosthog';

const MissingBankAccount = () => {
    const { accountId, paymentAccount } = useCurrentAccount();
    const { pushEvent } = usePosthog();
    const { apiUrl } = useAppState();
    const started = paymentAccount?.merchant_status === 'pending';

    return (
        <div className="flex flex-col gap-4">
            {!started && (
                <AlertNotification.Root type="error">
                    <AlertNotification.Icon />
                    <AlertNotification.Content>
                        <AlertNotification.Title>
                            Connect an account to publish your campaigns, begin accepting payments,
                            and withdraw your funds.{' '}
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                className={'text-red-700 underline'}
                                href={WITHDRAWALS_HELP_LINK}
                            >
                                How do withdrawals work?
                            </a>
                        </AlertNotification.Title>
                    </AlertNotification.Content>
                </AlertNotification.Root>
            )}
            {started && (
                <AlertNotification.Root type="warning">
                    <AlertNotification.Icon />
                    <AlertNotification.Content>
                        <AlertNotification.Title>
                            Your Stripe account is missing information. You must complete onboarding
                            to receive payouts.
                        </AlertNotification.Title>
                    </AlertNotification.Content>
                </AlertNotification.Root>
            )}
            <Box className="flex max-w-md flex-col items-start gap-4 p-6">
                <h2 className="flex gap-2 text-lg">
                    <FontAwesomeIcon icon={faBank} />
                    Bank Account
                </h2>
                <p>Connect a bank account or debit card to begin withdrawing funds.</p>
                {started ? (
                    <Button
                        variant="solid"
                        onClick={() => pushEvent(posthogEvents.MERCHANT_ACCOUNT_SETUP_STARTED)}
                    >
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            className={
                                'flex items-center gap-1 font-medium text-white hover:text-white'
                            }
                            href={`${apiUrl}/dashboard/accounts/${accountId}/payment_account_dashboard`}
                        >
                            Continue onboarding
                        </a>
                    </Button>
                ) : (
                    <Dialog.Root>
                        <Dialog.Trigger asChild={true}>
                            <Button
                                variant="outline"
                                color="neutral"
                                onClick={() =>
                                    pushEvent(posthogEvents.MERCHANT_ACCOUNT_SETUP_STARTED)
                                }
                            >
                                Connect
                            </Button>
                        </Dialog.Trigger>
                        <Dialog.Portal>
                            <Dialog.Overlay />
                            <VerifyBankModalContent />
                        </Dialog.Portal>
                    </Dialog.Root>
                )}
            </Box>
        </div>
    );
};

export { MissingBankAccount };
